/* WebComponentLabelPrintingPageTemplateTsx template */
import {Fragment, h} from '@stencil/core';

const WebComponentLabelPrintingPageTemplateTsx = (context) => {
  let I18N = context.ref.I18N;

  return (
      <Fragment>
          { context.ref.pageTemplateOverviewData && context.ref.pageTemplateOverviewData.data ? <dia-datatable
              api-url="/rest/datatable/getDataFromTable"
              header={JSON.stringify(context.ref.dataTableTemplatesHeader)}
              columns={context.ref.dataTableTemplatesColumns}
              options={JSON.stringify(context.ref.dataTableTemplatesOptions)}
              server-side
              table-class="LabelsPrintTemplatesTableSource"
              table-id="labelPrintingTemplateOverview"
          >
          </dia-datatable> : I18N.t('Keine Druckvorlagen vorhanden') }
      </Fragment>
  );
};

export default WebComponentLabelPrintingPageTemplateTsx;
